/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import {
	Box,
	Grid,
	Paper,
	useMediaQuery,
	Button,
	Drawer,
	Typography,
	Tooltip,
	IconButton
} from '@material-ui/core';
import { deepClone } from 'helper/helper';
import PrintMsg from './PrintMsg';
import ErrorPage from 'components/Shared/ErrorPage';
import { UserPortalContext } from 'context/appcontext';
import moment from 'moment';
import {
	NO_DATA,
	DEFAULT_ERR_MSG,
	PREVIEW_MSG,
	OMNI_TMPT_LIST,
	CANNED_REPORT_LIST,
	LINK_ITEMS_NUM_BTN_TEXT,
	STR_TMPT_LIST,
	ALL_LINK_ITEM_LIST,
	DC_TMPT_LIST,
	WK_SPEC_TMPT,
	PARENT_CUST_ATTR,
	CUSTOM_ATTRIBUTE,
	COLUMNS,
	OTIF_TMPT_LIST,
	OMNI_OTIF_ALERT_MESSAGE,
	PIVOT_WARNING_MSG,
	FORMATTED_OMNI_ALERT,
	PREVIEW,
	STR_ORDER_LIST,
	FILTER,
	MULTI_TIME_SELECTION,
	ITEM_SHARE_SELECTION,
	ITEM_ACCESS_TYPE_FIELD,
	ITEM_ACCESS_TYPE,
	SSI_STORE_TRAIT_ATTRS,
	SSI_STORE_TRAIT_REMOVAL_TOOLTIP,
	SSI_METRIC_SELECTION,
	OFGuideLocalStorageFlag,
	ORDER_FORECAST_DEFAULT_FILTER as OFDefaultFilters,
	SSIAllLinkRollupFolders,
	SSIAllLinkRollupViewName,
	BASIC,
	PIVOT_MTS_VALUE,
	PIVOT_SINGLE_TIME_VALUES,
	LINK_ITEM_ACTIVITY,
	FILTER_LOWER,
	WEEK_KEY,
	DAY_KEY,
	MONTH_KEY,
	QUARTER_KEY,
	YEAR_KEY,
	MTS_HEADER,
	PO_DATE_LIST,
	DATE_REFRESH_TIME_TIP,
	DATA_REFRESHED,
	DEFAULT_VARIANT_SELECTION,
	PURCHASE_ORDER_LIST,
	PREVIEW_STATUS,
	REGISTER_SALES_LIST,
	RS_METRIC_SELECTION,
	HISTORICAL_REPORT_OMNI
} from 'constants/constant';
import PreviewTableHeader from './PreviewTableHeader';
import previewTableStyles, { StyledTableContainer } from './PreviewTable.style';
import { setSelectedList, removePreviewColumn, setFilterList } from '../Preview.actions';
import { isCalFamily, isMTS, isMTSAndNotDefault, isMultiWeekSel } from '../filter/FilterCondition';
import Alert from './Alert.component';
import { FEATURES } from 'helper/basicFeatureFlag';
import { PreviewElementContext } from '../Preview.context';
import LinearScaleIcon from '@material-ui/icons/LinearScale';
import classNames from 'classnames';
import {
	buildBusinessName,
	hasPivotedColumn,
	hasTimeAcross,
	splitTableHeadersForPivot,
	splitTableHeadersForTimeAcross,
	isVariantAttrInTheList
} from '../Preview.utils';
import TableChartOutlinedIcon from '@material-ui/icons/TableChartOutlined';
import { getTmplName } from 'helper/utils';
import { getRefreshTime } from 'components/ReportSettings/ReportSettings.actions';
import { convertRefreshTime } from 'helper/helper';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import FilterListIcon from '@material-ui/icons/FilterList';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import ItemShare from 'components/Shared/ItemShare';
import CloseIcon from '@material-ui/icons/Close';
import Guide from './Guide.component';
import { isCustomDataset } from 'helper/utils';

export const defaultDrawerWidth = 360;
const minDrawerWidth = 360;
const maxDrawerWidth = 550;

function PreviewTable(props) {
	const {
		clearPreviewLoaded,
		setSelectedListCount,
		selectedListCount,
		setTotalSelected,
		reloadPreview,
		isLinkedItemPanelOpened,
		isColumnPanelOpened,
		isFilterPanelOpened,
		renderDrawerContent,
		show,
		filterTooltip = { show: false, msg: null },
		cbSSIComptability,
		ssiCompatibility
	} = props;

	const portalUserContext = useContext(UserPortalContext);
	const { userDetails } = portalUserContext;
	const { userPersona } = userDetails?.result;
	const editData = useSelector((state) => state.previewReducer.editData);
	const { selectedTemplate: templateId } = useSelector((state) => state.templateReducer);
	const classes = previewTableStyles();
	const isSmallScreen = useMediaQuery('(max-width:600px)');
	const dispatch = useDispatch();
	const [tableHeaders, setTableHeaders] = useState([]);
	const [alertList, setAlertList] = useState([]);
	const [refreshType, setRefreshType] = useState(null);
	const [drawerWidth, setDrawerWidth] = useState(defaultDrawerWidth);
	const { itemShareStatus, pivotOpts } = useSelector((state) => state.previewReducer);
	const [hierarchyMap, setHierarchyMap] = useState(new Map());
	const [localSSIComp, setLocalSSIComp] = useState(ssiCompatibility);
	const hierarchy = useSelector((state) => state.previewReducer.hierarchy);
	const selectedList = useSelector((state) => state.previewReducer.selectedList);
	const filterList = useSelector((state) => state.previewReducer.filterList);
	const previewData = useSelector((state) => state.previewReducer.previewData);
	const previewErrorCode = useSelector((state) => state.previewReducer.previewErrorCode);
	const isPreviewLoaded = useSelector((state) => state.previewReducer.isPreviewLoaded);
	const linkItemActivity = useSelector((state) => state.previewReducer.linkItemActivity);
	const selectedTemplate = useSelector((state) => state.templateReducer.selectedTemplate);

	const reportRefreshTime = useSelector((state) => state.reportSettingsReducer.reportRefreshTime);
	const templateData = useSelector((state) => state.templateReducer.templateData);
	const cannedReportData = useSelector((state) => state.templateReducer.cannedReportData);

	const { cbSetShowPreviewElement, cbUsrSelection, cbSetFilterTooltip } =
		useContext(PreviewElementContext);
	const { customerType } = portalUserContext;
	const { SHOW_SAMPLE_FIRST_ROW } = FEATURES[customerType].PREVIEW_PAGE;
	const mandatorySelection = useSelector((state) => state.previewReducer.mandatorySelection);
	const isRightPanelOpened = isColumnPanelOpened || isLinkedItemPanelOpened || isFilterPanelOpened;
	const pivotedColumn = hasPivotedColumn(pivotOpts?.pivotColumn);
	const timeAcrossEnabled = hasTimeAcross(pivotOpts);
	/* Order Forecast Guide on Table */
	const [showGuide, setShowGuide] = useState(false);
	const OFGuideWidth = isRightPanelOpened
		? `calc(100% - ${drawerWidth + 30}px)`
		: `calc(100% - 40px)`;
	const doNotShowOFTableGuide = JSON.parse(localStorage.getItem(OFGuideLocalStorageFlag));

	const closeGuide = () => setShowGuide(false);

	const removeItems = () => {
		// Remove default columns (headers and attributes)
		if (tableHeaders.length > 0) {
			const removedTableHeaders = [];
			const modifiedTableHeaders = [];
			tableHeaders.forEach((item) => {
				if (!OFDefaultFilters.includes(item.headerName)) {
					modifiedTableHeaders.push(item);
				} else {
					removedTableHeaders.push(item);
				}
			});
			setTableHeaders(modifiedTableHeaders);
			// Calculate & updates the count on Right panel header
			calculateCount(removedTableHeaders);
		}
		if (selectedList.length > 0) {
			const modifiedSelectedList = [];
			selectedList.forEach((item) => {
				if (!OFDefaultFilters.includes(item.businessName)) {
					modifiedSelectedList.push(item);
				}
			});
			dispatch(setSelectedList(modifiedSelectedList));
		}
		// Closes the Guide
		closeGuide();
	};

	useEffect(() => {
		let headerList = [];
		let headers = [];
		let lAlertList = [];

		/** No headers for the preview table to be added */
		if (!CANNED_REPORT_LIST.includes(Number(selectedTemplate))) {
			if (selectedList.length !== 0) {
				headerList = selectedList.map((item) => {
					let appendParent = '';
					/*
					 * if bussName is Week, Qtr and Year then append parent name in table header
					 */
					if ([WEEK_KEY, QUARTER_KEY, YEAR_KEY].includes(item.businessName)) {
						appendParent = `${item.parent} `;
					}
					let headerName =
						`${appendParent}` + buildBusinessName(item.businessName, selectedTemplate);
					// For MTS, headerName(Table column name) should be 'Multi time selection'
					if (item?.localName === MULTI_TIME_SELECTION) {
						headerName = MTS_HEADER;
					}
					return {
						headerName,
						field: getField(item),
						item: item,
						isFilterColAllowed: isFilterColAllowed(item),
						isDeleteColAllowed: isDeleteColAllowed(item)
					};
				});
				headers = deepClone(headerList);
			}

			if (previewData?.jsonResponse?.length !== 0) {
				if (OMNI_TMPT_LIST.includes(Number(selectedTemplate))) {
					lAlertList.push({
						msg: FORMATTED_OMNI_ALERT,
						id: 'FORMATTED_OMNI_ALERT',
						actionBtn: false
					});
				}
			}
			if (OTIF_TMPT_LIST.includes(Number(selectedTemplate))) {
				lAlertList.push({
					msg: OMNI_OTIF_ALERT_MESSAGE,
					id: 'OMNI_OTIF_ALERT_MESSAGE',
					actionBtn: false
				});
			} else if (STR_TMPT_LIST.includes(Number(selectedTemplate))) {
				lAlertList.push({
					msg: SSI_METRIC_SELECTION,
					id: 'SSI_METRIC_SELECTION',
					actionBtn: false
				});
			} else if (REGISTER_SALES_LIST.includes(Number(selectedTemplate))) {
				lAlertList.push({
					msg: RS_METRIC_SELECTION,
					id: 'RS_METRIC_SELECTION',
					actionBtn: false
				});
			}

			if (pivotedColumn) {
				lAlertList.push({
					msg: PIVOT_WARNING_MSG,
					id: 'PIVOT_ALERT',
					actionBtn: false
				});
			}
		}
		setAlertList(lAlertList);

		if (pivotedColumn) {
			/**
			 * Update the headers if Pivot is selected.
			 * timeSelections array will be used to split the table headers based on each value it holds
			 */
			let timeSelections = [];
			/**
			 * In single time, there are 3 cases,
			 * (1) Week selection, (2) Other WMT Calendar (Month, Quarter, Year) & (3) Hour attribute for Hourly Store Inventory template
			 * - For Week selection, since it has multiple options, condition field must be used to split the table headers
			 * - For other Walmart Calendar single time filters, use the time selection value from dropdown
			 * - For Hour attribute(snap_shout_hour) timeSelections will be the values User has checked from dropdown
			 */
			const snapShotHour = 'snap_shot_hour';
			const wmtCalWeeks = ['walmart_calendar_week', 'walmart_year_and_week'];
			const singleTimeAttributesWOWeek = PIVOT_SINGLE_TIME_VALUES.filter(
				(technicalName) => !wmtCalWeeks.includes(technicalName)
			);
			if (wmtCalWeeks.includes(pivotOpts?.pivotColumn)) {
				const _filterListObj = filterList?.find((e) => wmtCalWeeks.includes(e?.technicalName));
				timeSelections = _filterListObj?.filter?.condition?.split(',');
			} else if (singleTimeAttributesWOWeek.includes(pivotOpts?.pivotColumn)) {
				timeSelections = [filterList[0]?.filter?.condition];

				if (pivotOpts?.pivotColumn === snapShotHour) {
					const _filterListObj = filterList?.find((e) => e?.technicalName === snapShotHour);
					timeSelections = [..._filterListObj?.filter?.value];
				}
			} else if (pivotOpts?.pivotColumn === PIVOT_MTS_VALUE) {
				/**
				 * For MTS, all selected options are used to split the header
				 */
				const _filterListObj = filterList?.find((e) => e?.localName === MULTI_TIME_SELECTION);
				timeSelections = Object.keys(_filterListObj?.mts || {});
			}
			if (timeAcrossEnabled) {
				headers = splitTableHeadersForTimeAcross(headers, timeSelections);
			} else {
				headers = splitTableHeadersForPivot(headers, timeSelections);
			}
		}

		if (isVariantAttrInTheList(selectedList)) {
			// Column(Wmt item no.) added as a part of Variant ID/Desc, should not be deleted
			for (const h of headers) {
				if (h?.item?.businessName === DEFAULT_VARIANT_SELECTION) {
					h.isDeleteColAllowed = false;
					break;
				}
			}
		}

		setTableHeaders(headers);
	}, [selectedList, previewData.jsonResponse, filterList, pivotedColumn, timeAcrossEnabled]);

	useEffect(() => {
		//build a temp map for dimensions and measures, using technicalName as key
		let hmap = new Map();
		hierarchy?.map((folder) => {
			const dimensions = folder.dimensions ? deepClone(folder.dimensions) : undefined;
			dimensions?.forEach((dim) => {
				if (dim.technicalName) {
					hmap.set(dim.technicalName, dim);
				}
			});
			const measures = folder.measures ? deepClone(folder.measures) : undefined;
			measures?.forEach((mea) => {
				if (mea.technicalName) {
					hmap.set(mea.technicalName, mea);
				}
			});

			const periods = folder.periods ? deepClone(folder.periods) : [];
			periods.forEach((calendar) => {
				const subAttributes = calendar.subAttributes || [];
				subAttributes.forEach((subAttribute) => {
					if (subAttribute.technicalName) {
						hmap.set(subAttribute.technicalName, subAttribute);
					}
				});
			});
		});
		setHierarchyMap(hmap);
	}, [hierarchy]);

	useEffect(() => {
		setLocalSSIComp(ssiCompatibility);
	}, [ssiCompatibility]);

	const getField = (item) => {
		/**
		 * IMPORTANT: FIELDS CANNOT HAVE '.' IN IT. MAKE SURE TO REPLACE IT WITH '|'
		 */

		/**
		 * If multi time selection has been done then use the wm_time_window_week field to display the weeks
		 */
		const isMultiWeek = filterList.find(
			(el) => isMultiWeekSel(el, Number(templateId)) || isMTS(el)
		);
		if (isMultiWeek && item.technicalName === isMultiWeek?.technicalName) {
			return `${isMultiWeek.tableWeeklyMultiWindow}|wm_time_window_week`;
		}

		const isWeekSel = filterList.find((el) => el.businessName === WEEK_KEY);

		/**
		 * For SSI 'allLinkRollUp' selection,
		 * the first part of the field has always the SSIAllLinkRollupViewName value for all attributes under specific folders.
		 * Exception, attribute - item_access_type
		 */
		const isAttributeUnderFolder =
			item?.parent === 'dimensions' &&
			item?.technicalName !== 'item_access_type' &&
			SSIAllLinkRollupFolders.includes(item?.folderName);
		if (
			ALL_LINK_ITEM_LIST.includes(Number(selectedTemplate)) &&
			linkItemActivity === 'allLinkRollUp' &&
			isAttributeUnderFolder
		) {
			return `${SSIAllLinkRollupViewName}|${item.technicalName.trim()}`;
		}

		if (item.parent === PARENT_CUST_ATTR) {
			return `${item.table}|${item.technicalName}`;
		}

		if (isMultiWeek) {
			const colName = item.technicalNameMultiTime
				? item.technicalNameMultiTime
				: item.technicalName;

			if (item.tableWeeklyMultiWindow) {
				return `${item.tableWeeklyMultiWindow}|${colName}`;
			}
			return `${isMultiWeek.tableWeeklyMultiWindow}|${colName}`;
		}

		if (isWeekSel && WK_SPEC_TMPT.includes(Number(selectedTemplate))) {
			return `${item.tableWeekly}|${item.technicalName}`;
		}

		return `${item.table}|${item.technicalName}`;
	};

	const isDeleteColAllowed = (item) => {
		/**
		 * If all link item activity is selected then user should not be allowed to delete the column from the preview table
		 */
		if (
			linkItemActivity !== '' &&
			(item.technicalName === 'all_links_item_number' ||
				item.technicalName === 'walmart_item_number')
		) {
			return false;
		}

		/** For OMNI OTIF template "business_area" attribute should not be allowed to deselected */
		if (OTIF_TMPT_LIST.includes(Number(templateId)) && item.technicalName === 'business_area') {
			return false;
		}

		/** Item share - item access type shouldn't be allowed to removed. */
		if (item.businessName === ITEM_ACCESS_TYPE) {
			return false;
		}

		/** Item is multi week - column cannot be deleted */
		if (item.businessName === WEEK_KEY && item?.filter?.value?.length > 1) {
			return false;
		}

		/** Item is MTS - column cannot be deleted */
		if (item.businessName === WEEK_KEY && item?.localName === MULTI_TIME_SELECTION) {
			return false;
		}

		return true;
	};

	const isFilterColAllowed = (item) => {
		/** For OMNI OTIF Template, below fields should not be allowed to be filtered */
		if (OTIF_TMPT_LIST.includes(Number(templateId))) {
			const attrWithNoFilters = [
				'charge_status',
				'charged_ind',
				'p1e_ind',
				'has_accountability_info'
			];
			return !attrWithNoFilters.includes(item.dbtechnicalName);
		}

		/* Order Forecast attribute, filter not allowed */
		if (
			STR_ORDER_LIST.includes(Number(templateId)) &&
			item.businessName === 'Distribution Center Number'
		) {
			return false;
		}

		/* Purchase Order, filter not allowed for Walmart Week time period*/
		if (
			PURCHASE_ORDER_LIST.includes(Number(templateId)) &&
			item.businessName === PO_DATE_LIST.wmtCalendar
		) {
			return false;
		}

		/** No Filter allowed */
		if (item.businessName === ITEM_ACCESS_TYPE) {
			return false;
		}

		return item.dataType !== 'time';
	};

	const calculateCount = (value) => {
		const counters = deepClone(selectedListCount);
		value.forEach((el) => {
			let folderName = el.item.folderName;
			if (el.item.parent === PARENT_CUST_ATTR) {
				counters[CUSTOM_ATTRIBUTE]--;
			} else if (!isCalFamily(el.item)) {
				counters[folderName]--;
			}
		});

		setSelectedListCount(counters);
	};

	const updateHeaderList = (hNameList) => {
		const toBeDeletedHeader = tableHeaders.filter((item) => hNameList.includes(item.headerName));
		const list = tableHeaders.filter((item) => !hNameList.includes(item.headerName));
		setTableHeaders(list);
		const headerList = selectedList.filter((item) => {
			let appendParent = '';
			if ([WEEK_KEY, QUARTER_KEY, YEAR_KEY].includes(item.businessName)) {
				appendParent = `${item.parent} `;
			}
			const lName = `${appendParent}` + buildBusinessName(item.businessName, templateId);
			return !hNameList.includes(lName); // lName !== value;
		});
		dispatch(setSelectedList(headerList));
		setTotalSelected(headerList.length);
		calculateCount(toBeDeletedHeader);

		/**
		 * [SSI - Metric Selection] - if removed from table, then will also need to be removed from filter
		 */
		if (toBeDeletedHeader[0].item.parent === 'measures') {
			const _list = filterList.filter(
				(item) => item.businessName !== toBeDeletedHeader[0].item.businessName
			);
			dispatch(setFilterList(_list));
		}
	};

	const handleColumnDelete = (headerName, field) => {
		let headerNameList = [headerName];
		let fieldList = [field];
		// if item share enabled then remove column from ag-grid table
		if (itemShareStatus.curr && ITEM_SHARE_SELECTION.includes(headerName)) {
			/** if only one item share specific attr available then delete 
			| selected one and item access type
			| else just delete the selected attr	
			*/

			const itemShareSpecificAttrLen = selectedList.filter((el) => {
				return ITEM_SHARE_SELECTION.includes(el.businessName);
			}).length;

			if (itemShareSpecificAttrLen === 1) {
				for (let index = 0; index < selectedList.length; index++) {
					if (
						[mandatorySelection.businessName, headerName].includes(selectedList[index].businessName)
					) {
						const [tblName, colName] = field.split('|');
						headerNameList = [mandatorySelection.businessName, headerName];
						fieldList = [`${tblName}|${colName}`, `${tblName}|${ITEM_ACCESS_TYPE_FIELD}`];
					}
				}
			}
		}

		/** For SSI template or Custom dataset, if any column related to trait are deleted then we need to show a filter tooltip */
		const isCustomDS = isCustomDataset(selectedTemplate);
		if (STR_TMPT_LIST.includes(Number(selectedTemplate)) || isCustomDS) {
			if (SSI_STORE_TRAIT_ATTRS.ATTR_SELECTION_BUSS_NAME.includes(headerName)) {
				const isTraitAttrSelected = selectedList.find(
					(item) =>
						SSI_STORE_TRAIT_ATTRS.ATTR_SELECTION_TECHNICAL_NAME.includes(item.technicalName) &&
						item.businessName !== headerName
				);
				cbSetFilterTooltip({
					show: !isTraitAttrSelected,
					msg: (
						<Typography style={{ fontSize: '14px' }}>{SSI_STORE_TRAIT_REMOVAL_TOOLTIP}</Typography>
					)
				});
			} else {
				cbSetFilterTooltip({ show: false, msg: null });
			}
		}

		/** (For SSI) Sync the incompatibility attribute across PreviewTable and PreviewElement*/
		if (STR_TMPT_LIST.includes(Number(selectedTemplate)) || isCustomDataset(selectedTemplate)) {
			const hierarchyItem = hierarchyMap.get(field);
			let newSSICompatibility = deepClone(localSSIComp);
			if (hierarchyItem?.dataSet) {
				hierarchyItem.dataSet.forEach((name) => {
					if (newSSICompatibility.dataSet[name] > 0) {
						newSSICompatibility.dataSet[name]--;
					}
					if (newSSICompatibility.dataSet[name] === 0) {
						delete newSSICompatibility.dataSet[name];
					}
				});
			}
			if (hierarchyItem?.incompatible) {
				hierarchyItem.incompatible.forEach((el) => {
					if (newSSICompatibility.incompatibility[el] > 0) {
						newSSICompatibility.incompatibility[el]--;
					}
					if (newSSICompatibility.incompatibility[el] === 0) {
						delete newSSICompatibility.incompatibility[el];
					}
				});
				newSSICompatibility.incompatibilityAttr = newSSICompatibility.incompatibilityAttr.filter(
					(el) => el !== hierarchyItem.businessName
				);
			}
			cbSSIComptability(newSSICompatibility);
		}

		updateHeaderList(headerNameList);
		fieldList.forEach((field) => {
			dispatch(removePreviewColumn(previewData, field));
		});
	};

	useEffect(() => {
		if (selectedTemplate !== null) {
			const allData = [...templateData, ...cannedReportData];
			let result = allData.filter((item) => item.templateName === getTmplName(selectedTemplate))[0];
			const isCustomDS = isCustomDataset(selectedTemplate);
			if (isCustomDS) {
				result = allData.find((item) => item?.templateId === selectedTemplate);
			}

			// const isWeekSel = filterList?.some((el) => el.businessName === 'Week');
			if (result?.view?.length > 0) {
				let templateName = getTmplName(selectedTemplate);
				// TODO: Hard coding ssi's name for custom dataset as it doesnt have its own refresh time
				if (isCustomDS) {
					templateName = getTmplName('403');
				}
				dispatch(
					getRefreshTime({
						requestBody: {
							templateName: templateName,
							identifier: userPersona
						}
					})
				);
			}

			// Showing Order Forecast Guide on Table
			if (STR_ORDER_LIST.includes(Number(selectedTemplate))) {
				if (doNotShowOFTableGuide === null || !doNotShowOFTableGuide) {
					setShowGuide(true);
				}
			}
		}
	}, [templateData, cannedReportData, selectedTemplate]);

	const errorMsg = previewErrorCode === PREVIEW_STATUS.FAILURE ? DEFAULT_ERR_MSG : NO_DATA;

	const getAppliedFilterLen = () => {
		// Get all filters except MTS
		const allFiltersExceptMTS = filterList?.filter(
			(filter) => filter?.localName !== MULTI_TIME_SELECTION
		);
		// Check how many filters are applied based on their field.
		let appliedFilLength = allFiltersExceptMTS?.filter((o) => o.field !== undefined)?.length;
		// Check for MTS separately as "field" could be empty for MTS so checking field is not right for MTS
		if (filterList?.some((filter) => isMTSAndNotDefault(filter))) {
			appliedFilLength += 1;
		}
		return appliedFilLength;
	};

	const getClassName = (btn) => {
		const { linkItemsBtnActive, linkItemsBtnActiveWithBorder, linkItemsBtn } = classes;
		let actionPanel = isColumnPanelOpened;
		let isActiveBtn = isColumnPanelOpened || selectedList.length > 0;
		if (btn === LINK_ITEM_ACTIVITY) {
			isActiveBtn = isLinkedItemPanelOpened || linkItemActivity !== '';
			actionPanel = isLinkedItemPanelOpened;
		} else if (btn === FILTER_LOWER) {
			isActiveBtn = isFilterPanelOpened || getAppliedFilterLen() > 0;
			actionPanel = isFilterPanelOpened;
		}
		return classNames({
			[linkItemsBtnActiveWithBorder]: actionPanel,
			[linkItemsBtnActive]: isActiveBtn,
			[linkItemsBtn]: !isActiveBtn
		});
	};

	let tablePreviewData = previewData?.jsonResponse;
	/**
	 * For Basic users the Preview is disabled
	 * When user adds the columns to the table, the row should be filled with value equal to the attributes data type
	 *
	 * This is also applicable for the Pivot column selection
	 */
	const showSampleWholeTable = timeAcrossEnabled;
	const showSampleFirstRow = SHOW_SAMPLE_FIRST_ROW || (pivotedColumn && !timeAcrossEnabled);
	// Attribute data type map
	const dataTypeMap = {
		number: 'Number',
		string: 'Text',
		week: 'Week number',
		date: 'Date'
	};
	if (showSampleWholeTable) {
		const measures = selectedList.filter((item) => item.parent === 'measures');
		tablePreviewData = [];
		measures.forEach((measure) => {
			let rowObj = {};
			tableHeaders.forEach((header) => {
				let measureDataType = dataTypeMap[measure?.dataType];
				// Todo, fix the mapping
				if (header?.field === 'timeAcrossDataTypePlaceHolder') {
					rowObj.timeAcrossDataTypePlaceHolder = measure?.businessName;
				} else if (header?.item?.parent === 'times') {
					rowObj[header.field] = measureDataType;
				} else {
					const dataType = dataTypeMap[header?.item?.dataType];
					const colField =
						pivotedColumn && customerType !== BASIC
							? header?.field?.split('|')?.[1]
							: header?.field;
					rowObj[colField] = dataType;
				}
			});
			tablePreviewData.push(rowObj);
		});
	} else if (showSampleFirstRow) {
		// Attribute data type map
		const firstRowObject = {};
		tableHeaders.forEach((header) => {
			let dataType = dataTypeMap[header?.item?.dataType];
			if (header?.item?.businessName?.toLowerCase().includes('quarter')) {
				// Quarter => Text
				dataType = dataTypeMap.string;
			}
			if (header?.item?.businessName?.toLowerCase().includes('week')) {
				// Week => Number
				dataType = dataTypeMap.number;
			}
			// Todo, fix the mapping
			const colField =
				pivotedColumn && customerType !== BASIC ? header?.field?.split('|')?.[1] : header?.field;
			firstRowObject[colField] = dataType;
		});
		tablePreviewData = [firstRowObject];
	}

	useEffect(() => {
		const weekMonthQuarterYear = [WEEK_KEY, MONTH_KEY, QUARTER_KEY, YEAR_KEY];
		const nonDateFilter = filterList.find((el) => weekMonthQuarterYear.includes(el.businessName));
		const isWeekFilterSel = nonDateFilter && nonDateFilter.filter.condition !== '';
		const isDateFilterSel = filterList.find((el) => el.businessName === 'Date');
		const isDateColumnSel = selectedList?.find((column) => column.businessName === 'Date');
		const isCDSReport = isCustomDataset(selectedTemplate);

		if (
			isWeekFilterSel &&
			([
				...STR_TMPT_LIST,
				...DC_TMPT_LIST,
				...REGISTER_SALES_LIST,
				...HISTORICAL_REPORT_OMNI
			].includes(Number(selectedTemplate)) ||
				isCDSReport)
		) {
			setRefreshType('Week');
		}
		if (isDateFilterSel || isDateColumnSel) {
			setRefreshType(DAY_KEY);
		}
	}, [filterList, selectedList]);

	const getConvertedRefreshTime = () => {
		const time = convertRefreshTime(
			moment(
				refreshType === WEEK_KEY
					? reportRefreshTime.refreshTimeWeekly
					: reportRefreshTime.refreshTime
			)
		);
		const isCDSReport = isCustomDataset(selectedTemplate);

		if (
			([
				...STR_TMPT_LIST,
				...DC_TMPT_LIST,
				...REGISTER_SALES_LIST,
				...HISTORICAL_REPORT_OMNI
			].includes(Number(selectedTemplate)) ||
				isCDSReport) &&
			refreshType === null
		) {
			return (
				<>
					<span>/-/-/</span>
					<Tooltip
						arrow
						title={`${DATE_REFRESH_TIME_TIP}`}
						placement={isSmallScreen ? 'left' : 'bottom'}
						classes={{ tooltip: classes.tooltip }}>
						<IconButton aria-label="data-refresh-info">
							<InfoOutlinedIcon fontSize="small" />
						</IconButton>
					</Tooltip>
				</>
			);
		} else {
			return <span>{`${time.day}, ${time.date} ${time.time} ${time.timezone}`}</span>;
		}
	};

	const updateAlertList = (alertId) => {
		let list = deepClone(alertList);
		list = list.filter((el) => el.id !== alertId);
		setAlertList(list);
	};

	const handleMouseDown = () => {
		document.addEventListener('mouseup', handleMouseUp, true);
		document.addEventListener('mousemove', handleMouseMove, true);
	};

	const handleMouseUp = () => {
		document.removeEventListener('mouseup', handleMouseUp, true);
		document.removeEventListener('mousemove', handleMouseMove, true);
	};

	const handleMouseMove = useCallback((e) => {
		let newWidth = document.body.offsetWidth - e.clientX;
		if (newWidth > minDrawerWidth && newWidth < maxDrawerWidth) {
			setDrawerWidth(newWidth);
		}
	}, []);

	return (
		<Grid container className={classes.containerHeight}>
			<Box className={classes.linkItemsBtnContainer} style={{ zIndex: 2 }}>
				<Box>
					<Button
						id="columns"
						color="primary"
						className={getClassName()}
						startIcon={<TableChartOutlinedIcon style={{ height: '14px' }} />}
						onClick={() => {
							if (
								previewErrorCode === PREVIEW_STATUS.FAILURE ||
								(isPreviewLoaded === true && previewData?.jsonResponse.length === 0)
							) {
								dispatch(clearPreviewLoaded());
							}
							cbSetShowPreviewElement('columns');
						}}>
						{COLUMNS}
						{selectedList.length > 0 && (
							<span className="userCount">{` ${selectedList.length}`}</span>
						)}
					</Button>
					<Tooltip
						open={filterTooltip.show}
						arrow
						classes={{ arrow: classes.filterTooltipArrow, tooltip: classes.filterTooltip }}
						placement="bottom-start"
						title={
							<Box className={classes.filterTooltipContainer}>
								{filterTooltip.msg}

								<IconButton
									disableRipple
									className={classes.filterTooltipCloseBtn}
									onClick={() => cbSetFilterTooltip(false)}>
									<CloseIcon style={{ height: '16px' }} />
								</IconButton>
							</Box>
						}>
						<Button
							id="filter-txt-lbl"
							color="primary"
							className={getClassName(FILTER_LOWER)}
							startIcon={
								<FilterListIcon
									fontSize="small"
									style={{ display: 'flex', alignItems: 'center', marginTop: '2px' }}
								/>
							}
							onClick={() => {
								cbUsrSelection([]);
								cbSetShowPreviewElement(FILTER_LOWER);
								cbSetFilterTooltip(false);
							}}>
							{FILTER}
							{getAppliedFilterLen() > 0 && (
								<span className="userCount" id="filterCount">{` ${getAppliedFilterLen()}`}</span>
							)}
						</Button>
					</Tooltip>
					{ALL_LINK_ITEM_LIST.includes(Number(selectedTemplate)) && (
						<Button
							id="linked-item-activity"
							color="primary"
							className={getClassName(LINK_ITEM_ACTIVITY)}
							startIcon={<LinearScaleIcon alt="linear scale-icon" />}
							onClick={() => cbSetShowPreviewElement(LINK_ITEM_ACTIVITY)}>
							{LINK_ITEMS_NUM_BTN_TEXT}
						</Button>
					)}
				</Box>
				<Box style={{ display: 'flex', alignItems: 'center' }}>
					<ItemShare
						divider
						setSelectedListCount={setSelectedListCount}
						selectedListCount={selectedListCount}
					/>

					<Box className={classes.dataRefresh} key={refreshType} style={{ width: 260 }}>
						<span style={{ fontWeight: 'bold' }}>{`${DATA_REFRESHED}`}&nbsp;</span>
						{reportRefreshTime ? getConvertedRefreshTime() : <span>/-/-/</span>}
					</Box>
				</Box>
			</Box>
			{previewErrorCode === PREVIEW_STATUS.FAILURE ||
			(isPreviewLoaded === true && previewData?.jsonResponse.length === 0) ? (
				<Box className={classes.errorContainer} style={{ zIndex: 2 }}>
					<ErrorPage
						errorMsg={errorMsg}
						isSmallScreen={isSmallScreen}
						reload={reloadPreview}
						ok={previewData?.jsonResponse.length === 0}
						clearPreviewLoaded={clearPreviewLoaded}
					/>
				</Box>
			) : (
				<Grid className={classes.wrapper} style={{ zIndex: 2 }}>
					<Alert
						isError={editData?.status === 'FAILED'}
						onClose={updateAlertList}
						alertList={alertList}
						isRightPanelOpened={isRightPanelOpened}
						drawerWidth={drawerWidth}
					/>

					{/* Order forecast Guide */}
					{showGuide ? (
						<Guide width={OFGuideWidth} onClose={closeGuide} onRemoveItems={removeItems} />
					) : null}

					{previewData?.jsonResponse?.length > 0 && (
						<Box className={classes.previewBox} style={{ zIndex: 2 }}>
							<Typography style={{ fontSize: 12, fontWeight: 400, letterSpacing: 0.2 }}>
								{PREVIEW.toUpperCase()}
							</Typography>
							<Tooltip
								title={PREVIEW_MSG}
								placement="bottom"
								PopperProps={{
									popperOptions: {
										positionFixed: true,
										modifiers: {
											preventOverflow: {
												boundariesElement: 'window'
											}
										}
									}
								}}
								aria-label="add"
								classes={{ tooltip: classes.customTootipCss }}
								arrow>
								<ErrorOutlineIcon style={{ fontSize: 14, marginLeft: 8 }} />
							</Tooltip>
						</Box>
					)}

					<StyledTableContainer
						component={Paper}
						className={classes.tableContainer}
						style={{ paddingTop: 0, position: 'fixed' }}>
						<PreviewTableHeader
							handleColumnDelete={handleColumnDelete}
							headers={tableHeaders}
							previewData={tablePreviewData}
							isRightPanelOpened={
								isColumnPanelOpened || isLinkedItemPanelOpened || isFilterPanelOpened
							}
							noOfMsg={alertList.length}
							drawerWidth={drawerWidth}
						/>
					</StyledTableContainer>
					<PrintMsg />
					<Drawer
						variant="persistent"
						anchor="right"
						open={show}
						className={classes.drawer}
						PaperProps={{ style: { width: drawerWidth } }}>
						<div onMouseDown={(e) => handleMouseDown(e)} className={classes.dragger} />
						<Box className={classes.drawerContainer} style={{ width: drawerWidth }}>
							{renderDrawerContent(drawerWidth)}
						</Box>
					</Drawer>
				</Grid>
			)}
		</Grid>
	);
}

PreviewTable.propTypes = {
	clearPreviewLoaded: PropTypes.func.isRequired,
	setSelectedListCount: PropTypes.func.isRequired,
	selectedListCount: PropTypes.shape({}).isRequired,
	setTotalSelected: PropTypes.func.isRequired,
	reloadPreview: PropTypes.func
};

export default PreviewTable;
